<template>
  <div id="app">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style>
*{padding:0;margin:0}
body{background: url('./assets/images/baby.jpg');background-size:cover}
ul{list-style: none}
/* a{color:#666;text-decoration: none} */
</style>
